import { t } from "./i18n.js";
import type { Activity } from "./types.js";

export interface ActivityGroup {
  key: string;
  label: string;
  activities: Activity[];
}

export function groupActivitiesByMonth(
  activities: Activity[],
): ActivityGroup[] {
  const now = new Date();
  const currentKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const groups = new Map<string, Activity[]>();

  for (const activity of activities) {
    const date = new Date(activity.time);
    if (Number.isNaN(date.getTime())) continue;
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    const existing = groups.get(key);
    if (existing) {
      existing.push(activity);
    } else {
      groups.set(key, [activity]);
    }
  }

  const lang = document.documentElement.lang || "en";
  const result: ActivityGroup[] = [];

  for (const [key, groupActivities] of groups) {
    let label: string;
    if (key === currentKey) {
      label = t("group_latest");
    } else {
      const [year, month] = key.split("-");
      const date = new Date(Number(year), Number(month) - 1, 1);
      const monthName = date.toLocaleDateString(lang, { month: "long" });
      label = monthName.charAt(0).toUpperCase() + monthName.slice(1);
      if (Number(year) !== now.getFullYear()) {
        label += ` ${year}`;
      }
    }

    result.push({ key, label, activities: groupActivities });
  }

  // Sort groups by key descending (newest month first)
  result.sort((a, b) => b.key.localeCompare(a.key));

  return result;
}

export function filterActivities(
  activities: Activity[],
  query: string,
): Activity[] {
  if (!query) return activities;
  const lowerQuery = query.toLowerCase();
  return activities.filter((activity) => {
    const merchant = (activity.actor.name ?? "").toLowerCase();
    return merchant.includes(lowerQuery);
  });
}

export function getActivityInitial(activity: Activity): string {
  const name = activity.actor?.name ?? "";
  return name.charAt(0).toUpperCase() || "?";
}
